import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js'
import SettingsNavigator from 'trunks/vue/admin/compositions/settings_sidebar/settings_navigator.js'
import SettingsMenu from 'trunks/vue/admin/components/settings/settings_container/settings_menu.js'

class Admin__MenusController extends Skylark.App.BaseController {
  show() {
    this._generateSettingsSidebarView('settings__menu')
    Skylark.Libs.Ajax.get('/admin/settings/menu.json', {
      responseType: 'json',
      success: (data) => {
        new SettingsMenu({
          el: DomMaster.find('#js-settings-menu').node,
          propsData: {
            activeTab: 'settings__menu',
            menuData: data
          }
        })
      }
    })
  }
}

Admin__MenusController.include(GenerateMorePopover, SettingsNavigator)

Skylark.App.Controllers.register({
  Admin__MenusController
})

export default Admin__MenusController
